import * as actions from 'actions';

const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.AUTH_UPDATE: {
      return action.authData.user;
    }

    case actions.USER_UPDATE_SUCCESS: {
      if (action.updates.avatar) {
        return {
          ...state,
          avatar: {
            id: action.updates.avatar,
            url: action.avatarUrl
          }
        };
      }

      return state;
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/user/profile/reducer.js
 **/